import React from 'react';
import { useIntl } from 'react-intl';
import { Badge } from './Badge.esm.js';

const NewBadge = ({ dataMetrics, dataTestId, }) => {
    const intl = useIntl();
    return (React.createElement(Badge, { dataMetrics: dataMetrics, dataTestId: dataTestId || "badge-new", appearance: "blue" }, intl.formatMessage({ id: "79p9Kf", defaultMessage: [{ type: 0, value: "New" }] })));
};

export { NewBadge };
//# sourceMappingURL=NewBadge.esm.js.map
